import * as React from 'react'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion'
import Link from 'next/link'
import clsx from 'clsx'
const ProductInfo = ({ sku, metadata }: { sku: string; metadata?: Record<string, unknown> | null }) => {
    const manual = metadata?.manual as string
    const rimSize = metadata?.rim_size as string
    const labelSound = metadata?.label_sound as string
    const labelEnergyGrip = metadata?.label_energy_grip as string
    const labelEnergyUsage = metadata?.label_energy_usage as string

    const rows = [
        {
            key: 'Artikelnummer',
            value: sku,
        },
        ...(manual
            ? [
                  {
                      key: 'Handleiding',
                      value: (
                          <a aria-label="download" href={manual} target="_blank" className="hover:text-brand-red">
                              download
                          </a>
                      ),
                  },
              ]
            : []),
        ...(rimSize
            ? [
                  {
                      key: 'Velg maat',
                      value: rimSize,
                  },
              ]
            : []),
        ...(labelSound
            ? [
                  {
                      key: 'Geluids label',
                      value: labelSound,
                  },
              ]
            : []),
        ...(labelEnergyGrip
            ? [
                  {
                      key: 'Energie label',
                      value: labelEnergyGrip,
                  },
              ]
            : []),
        ...(labelEnergyUsage
            ? [
                  {
                      key: 'Energie verbruik label',
                      value: labelEnergyUsage,
                  },
              ]
            : []),
    ].filter(row => !!row.value)

    return (
        <Accordion type="single" collapsible>
            <AccordionItem value="item-1">
                <AccordionTrigger>Productinfo</AccordionTrigger>
                <AccordionContent>
                    {rows.map(({ key, value }, index) => (
                        <div
                            key={index}
                            className={clsx('flex items-center justify-between py-4', {
                                'border-b': index !== rows.length - 1,
                            })}
                        >
                            <div className="font-medium">{key}</div>
                            <div>{value}</div>
                        </div>
                    ))}
                </AccordionContent>
            </AccordionItem>
        </Accordion>
    )
}

export default ProductInfo
